const transformAll = ({ data }) => data.regions.map(({ id, name }) => ({ id, name }));

const transformBeforeUpdate = data => {
  return data;
};

export { transformAll, transformBeforeUpdate };
